import React, {useState, useEffect} from 'react'

const SumsCells = (props) => {

    const [ totalRoutes, setTotalRoutes ] = useState(null)
    const [ totalMiles, setTotalMiles ] = useState(null)
    const [ totalLWP, setTotalLWP ] = useState(null)
    const [ totalLVP, setTotalLVP ] = useState(null)
    const [ totalTraining, setTotalTraining ] = useState(null)
    const [ totalSupport, setTotalSupport ] = useState(null)
    const [ totalR2, setTotalR2 ] = useState(null)
    const [ totalR4, setTotalR4 ] = useState(null)
    const [ totalR6, setTotalR6 ] = useState(null)
    const [ totalJumper, setTotalJumper ] = useState(null)

    useEffect( () => {
        if (props.routeAmount >= 0) {
            setTotalRoutes(<td className='sumsRows'>{props.routeAmount}</td>)
        } else {
            setTotalRoutes(<td className='sumsRowsRed'>{props.routeAmount}</td>)
        }

        // Miles
        props.miles >= 0 ? setTotalMiles(<td className='sumsRows'>{props.miles}</td>) : setTotalMiles(<td className='sumsRowsRed'>{props.miles}</td>)

        // R2
        props.R2 >= 0 ? setTotalR2(<td className='sumsRows'>{props.R2}</td>) : setTotalR2(<td className='sumsRowsRed'>{props.R2}</td>)

        // R4
        props.R4 >= 0 ? setTotalR4(<td className='sumsRows'>{props.R4}</td>) : setTotalR4(<td className='sumsRowsRed'>{props.R4}</td>)

        // R6
        props.R6 >= 0 ? setTotalR6(<td className='sumsRows'>{props.R6}</td>) : setTotalR6(<td className='sumsRowsRed'>{props.R6}</td>)

        // jumper
        props.Jumper >= 0 ? setTotalJumper(<td className='sumsRows'>{props.Jumper}</td>) : setTotalJumper(<td className='sumsRowsRed'>{props.Jumper}</td>)


        props.LWP >= 0 ? setTotalLWP(<td className='sumsRows'>{props.LWP}</td>) : setTotalLWP(<td className='sumsRowsRed'>{props.LWP}</td>)
        props.LVP >= 0 ? setTotalLVP(<td className='sumsRows'>{props.LVP}</td>) : setTotalLVP(<td className='sumsRowsRed'>{props.LVP}</td>)
        props.Training >= 0 ? setTotalTraining(<td className='sumsRows'>{props.Training}</td>) : setTotalTraining(<td className='sumsRowsRed'>{props.Training}</td>)
        props.support >= 0 ? setTotalSupport(<td className='sumsRows'>{parseFloat(props.support).toFixed(2)}</td>) : setTotalSupport(<td className='sumsRowsRed'>{parseFloat(props.support).toFixed(2)}</td>)
    }, [props])

    return(
        <>
            <td className='bigRowTotal'>{props.day}</td>
            <tr>
                <td className='sumsRows'>H2OL</td>
                {totalRoutes}
                {totalMiles}
                {totalLWP}
                {totalLVP}
                {totalJumper}
                {totalTraining}
                {totalSupport}
                {totalR2}
                {totalR4}
                {totalR6}
                <td className='sumsRows'>{props.Missort4th}</td>
                <td className='sumsRows'>{props.Missort6th}</td>
                <td className='sumsRows'>{props.DPMOBONUS}</td>
            </tr>
        </>
    )
}

export default SumsCells